"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetCommunityPoolParticipantsResponseToJSON = exports.GetCommunityPoolParticipantsResponseFromJSONTyped = exports.GetCommunityPoolParticipantsResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function GetCommunityPoolParticipantsResponseFromJSON(json) {
    return GetCommunityPoolParticipantsResponseFromJSONTyped(json, false);
}
exports.GetCommunityPoolParticipantsResponseFromJSON = GetCommunityPoolParticipantsResponseFromJSON;
function GetCommunityPoolParticipantsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'participants': !(0, runtime_1.exists)(json, 'participants') ? undefined : (json['participants'].map(_1.CommunityPoolParticipantFromJSON)),
        'totalCount': !(0, runtime_1.exists)(json, 'totalCount') ? undefined : json['totalCount'],
        'page': !(0, runtime_1.exists)(json, 'page') ? undefined : json['page'],
        'limit': !(0, runtime_1.exists)(json, 'limit') ? undefined : json['limit'],
    };
}
exports.GetCommunityPoolParticipantsResponseFromJSONTyped = GetCommunityPoolParticipantsResponseFromJSONTyped;
function GetCommunityPoolParticipantsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'participants': value.participants === undefined ? undefined : (value.participants.map(_1.CommunityPoolParticipantToJSON)),
        'totalCount': value.totalCount,
        'page': value.page,
        'limit': value.limit,
    };
}
exports.GetCommunityPoolParticipantsResponseToJSON = GetCommunityPoolParticipantsResponseToJSON;
